import getFetcher from 'common-swr/utils/fetcher';
import { javaClient } from '../../utils/api';

const baseFetcher = getFetcher(javaClient);

export default baseFetcher;
